import React, { useContext, useState } from 'react';
import { HiOutlinePencilSquare, HiOutlineCheck, HiOutlineXMark } from 'react-icons/hi2';
import { PlaybookContext } from '../context/PlaybookContext';

export default function PlaybookName() {
    const { action, saveSettings, settingsSaving } = useContext(PlaybookContext);
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState('');
    const [error, setError] = useState('');
    const submit = async () => {
        if (settingsSaving) return;
        if (!draft.trim()) { setError('Give the playbook a name.'); return; }
        setError('');
        try {
            await saveSettings({ name: draft.trim() });
            setEditing(false);
        } catch (e) { setError(e.message); }
    };
    return (
        <span className="inline-flex max-w-full flex-col gap-1">
            {editing ? (
                <span className="flex items-center gap-2">
                    <input autoFocus aria-label="Playbook name" value={draft} disabled={settingsSaving}
                        onChange={e => setDraft(e.target.value)}
                        onKeyDown={e => {
                            if (e.key === 'Enter') { e.preventDefault(); submit(); }
                            if (e.key === 'Escape' && !settingsSaving) { setEditing(false); setError(''); }
                        }}
                        className="w-64 max-w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 focus:border-primary focus:ring-primary" />
                    <button type="button" aria-label="Save playbook name" disabled={settingsSaving} onClick={submit} className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 disabled:opacity-50"><HiOutlineCheck size={18} /></button>
                    <button type="button" aria-label="Cancel name edit" disabled={settingsSaving} onClick={() => { setEditing(false); setError(''); }} className="rounded-lg p-2 text-gray-400 hover:bg-gray-100"><HiOutlineXMark size={18} /></button>
                </span>
            ) : (
                <button type="button" aria-label="Edit playbook name" disabled={settingsSaving} onClick={() => { setDraft(action?.name || ''); setEditing(true); }} className="group inline-flex items-center gap-3 rounded-lg text-left hover:bg-gray-50">
                    <span className="max-w-xs truncate sm:max-w-lg">{action?.name || 'Playbook'}</span>
                    <HiOutlinePencilSquare size={18} className="shrink-0 text-gray-400 group-hover:text-gray-900" />
                </button>
            )}
            {settingsSaving && editing && <span role="status" className="text-xs font-normal text-gray-500">Saving name…</span>}
            {error && <span role="alert" className="text-sm font-normal text-rose-600">{error}</span>}
        </span>
    );
}
